/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React from 'react'
import './SwapItem.css'
import { Element } from "trux"

const SwapItem = (props) => {

    const displayTraceNumber = () => {
        var num = props.traceNumber
        if (num <= 0) {
            num = '?'
        }
        return num
    }

    const traceNumber = () => {
        return parseInt(props.traceNumber, 10)
    }

    const currentTraceNumber = () => {
        return parseInt(props.current, 10)
    }

   const onShieldClick = () => {
       if (props.onClick) {
           props.onClick(props.traceNumber)
       }
   }

   const currentClass = currentTraceNumber() === traceNumber() ? 'current' : ''
   const unassignedClass = props.traceNumber <= 0 ? 'unassigned' : ''
   const emptyClass = props.empty ? 'empty' : ''

   return (
   <Element className={`SwapItem ${emptyClass} ${unassignedClass} ${currentClass}`}>
        <Element className="shield" onClick={onShieldClick}>
            <Element className="number">
                {displayTraceNumber()}
            </Element>
        </Element>
    </Element>
    )   
}

export default SwapItem